import api from "@/lib/api";

const KEY = "holaradar_device_id";
const GPS_KEY = "holaradar_gps_on";

export function getDeviceId() {
  return localStorage.getItem(KEY);
}

export function setDeviceId(id) {
  localStorage.setItem(KEY, id);
}

export async function ensureAnonUser() {
  const existing = getDeviceId();
  if (existing) {
    try {
      const { data } = await api.get(`/users/anon/${existing}`);
      return data;
    } catch (e) {
      localStorage.removeItem(KEY);
    }
  }
  const { data } = await api.post("/users/anon");
  setDeviceId(data.device_id);
  return data;
}

export function getGpsLocal() {
  const v = localStorage.getItem(GPS_KEY);
  return v === null ? true : v === "true";
}

export function setGpsLocal(v) {
  localStorage.setItem(GPS_KEY, String(v));
}
